import { useSelector } from 'react-redux';
import { selectTimeTrackingDate, selectTimeTrackingWeek, selectTimeTrackingWeekISO } from '../../store/slices/time-tracking.slice';

export const useTimeTrackingTimestamp = () => {
    const timeTrackingDate = useSelector(selectTimeTrackingDate);
    const timeTrackingWeek = useSelector(selectTimeTrackingWeek);
    const timeTrackingWeekISO = useSelector(selectTimeTrackingWeekISO);

    return { timeTrackingDate, timeTrackingWeek, timeTrackingWeekISO };
};
